/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

const regionDisplayNames = {
  'us-east-1': 'N. Virginia',
  'us-east-2': 'Ohio',
  'us-west-1': 'N. California',
  'us-west-2': 'Oregon',
  'af-south-1': 'Cape Town',
  'ap-east-1': 'Hong Kong',
  'ap-east-2': 'Taipei',
  'ap-south-1': 'Mumbai',
  'ap-south-2': 'Hyderabad',
  'ap-northeast-1': 'Tokyo',
  'ap-northeast-2': 'Seoul',
  'ap-northeast-3': 'Osaka',
  'ap-southeast-1': 'Singapore',
  'ap-southeast-2': 'Sydney',
  'ap-southeast-3': 'Jakarta',
  'ap-southeast-4': 'Melbourne',
  'ap-southeast-5': 'Malaysia',
  'ap-southeast-6': 'New Zealand',
  'ap-southeast-7': 'Thailand',
  'ca-central-1': 'Canada',
  'ca-west-1': 'Calgary',
  'eu-central-1': 'Frankfurt',
  'eu-central-2': 'Zurich',
  'eu-north-1': 'Stockholm',
  'eu-south-1': 'Milan',
  'eu-south-2': 'Spain',
  'eu-west-1': 'Ireland',
  'eu-west-2': 'London',
  'eu-west-3': 'Paris',
  'il-central-1': 'Tel Aviv',
  'mx-central-1': 'Mexico',
  'me-central-1': 'UAE',
  'me-south-1': 'Bahrain',
  'sa-east-1': 'São Paulo',
};

/**
 * Returns a plain-text friendly display string for a region code.
 * e.g. 'ap-southeast-2' → 'Sydney (ap-southeast-2)'
 * Falls back to the raw code if no friendly name is known.
 */
function getRegionDisplayText(regionCode) {
  const friendly = regionDisplayNames[regionCode];
  return friendly ? `${friendly} (${regionCode})` : regionCode;
}

export { regionDisplayNames, getRegionDisplayText };
